export default "__VITE_ASSET__BwOcg2sB__"